import { Button, Card, Modal, Space, Typography } from "antd";
import React, { useState } from "react";
import { CopyBlock } from "react-code-blocks";
import { PDFDownloadLink } from "@react-pdf/renderer";
import SignUpsInstructionPDF from "./pdf/SignUpsInstructionPDF";
import "../../../../../core/utils/polyfills"; // Initialize browser polyfills
import '../../styles/index.scss';

const { Title, Paragraph } = Typography;
const SignUpsIntroductionsModal = ({ signUpsGeneratedTag }) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  return (
    <React.Fragment>
      <Modal
        title="Instructions - Measuring Sign Up Events"
        wrapClassName="tags-modal tags-modal--narrow"
        visible={isModalVisible}
        centered
        onCancel={() => setIsModalVisible(false)}
        footer={
          <PDFDownloadLink
            document={<SignUpsInstructionPDF />}
            fileName="Sign Up Instructions.pdf"
          >
            {({ loading, error }) => {
              if (error) {
                return (
                  <Button type="primary" shape="round" danger disabled>
                    PDF Error - Use Copy Code Above
                  </Button>
                );
              }
              return (
                <Button 
                  type="primary" 
                  shape="round" 
                  loading={loading}
                  disabled={loading}
                >
                  {loading ? 'Generating PDF...' : 'Download PDF'}
                </Button>
              );
            }}
          </PDFDownloadLink>
        }
      >
        <Space direction="vertical">
          <Title level={5}>Tracking Sign-Ups</Title>
          <Paragraph>
            Execute this javascript on a Sign Up event. The static values above are supposed to
            represent the variables that pertain to the context of data you would pass in
            programmatically from your site. Swap out the static values with your own site’s form
            properties during a Sign Up event. The fastest way to start measuring Sign Ups is to
            place this snippet of javascript yourself, however our Integrations Team is here to
            provide assistance if needed.
          </Paragraph>
          <Card>
            <CopyBlock
              text={signUpsGeneratedTag}
              language="javascript"
              wrapLongLines
              theme="dracula"
            />
          </Card>
        </Space>
      </Modal>
      <Button shape="round" type="primary" onClick={() => setIsModalVisible(true)}>
        View Instructions
      </Button>
    </React.Fragment>
  );
};

export default SignUpsIntroductionsModal;
